import formatMoney from './../../../scripts/helpers/format-money'

export default class MarketingImageTextList {
  constructor(component) {
    this.dom = {
      $component: component,
      $customerPoints: document.querySelector('.js-customerPoints'),
      $yotpoList: component.querySelector('.js-yotpoList'),
      $rewardsList: document.querySelector('.js-marketingYotpoRewards')
    }
    this.state = {
      pointCount: 0,
      checkPointCountCount: 0,
      checkPointCountLimit: 10
    }
    this.mount()
    this.bindToWindow()
  }

  mount() {
    const {dom} = this
    if (dom.$yotpoList || dom.$rewardsList || dom.$customerPoints) {
      this.getRewards()
    }
  }

  getRewards() {
    const self = this

    Object.defineProperty(window, 'swellConfig', {
      configurable: true,
      enumerable: true,
      get() {
        return this._swellConfig
      },
      set(val) {
        this._swellConfig = val
        if (self.dom.$yotpoList) self.mountCampaigns(val.activeCampaigns)
        if (self.dom.$rewardsList) self.mountRewards(val.activeNonVariableRedemptionOptions)
        if (self.dom.$customerPoints) self.checkPointCount()
      }
    })
  }

  checkPointCount() {
    const {dom, state} = this
    if (state.checkPointCountCount > state.checkPointCountLimit) return
    state.checkPointCountCount++

    const setCount = window.swellConfig.customer.points_balance
    dom.$customerPoints.textContent = setCount

    if (state.pointCount !== setCount) {
      state.pointCount = setCount
    }

    setTimeout(() => this.checkPointCount(), 250)
  }

  mountCampaigns(campaigns) {
    const {dom} = this

    campaigns.forEach(campaign => {
      if (campaign.type === 'ReferralCampaign') return

      const div = document.createElement('div')
      const icon = document.querySelector(`.js-rewardIcon[data-icon="${campaign.icon}"]`)

      div.className = 'MarketingImageTextList__listItem'
      div.innerHTML = `
        <div class="MarketingImageTextList__listItem__title">
          <span class="MarketingImageTextList__listItem__iconWrap">
            ${icon ? icon.innerHTML : ''}
          </span>
          <span class="rmh4">
            ${campaign.reward_text}
          </span>
        </div>
        <div class="MarketingImageTextList__listItem__text rmp">
          ${campaign.title}
        </div>
      `
      dom.$yotpoList.append(div)
    })
  }

  mountRewards(rewards) {
    const {dom} = this
    const accountArrow = document.querySelector('.js-rewardIcon[data-icon="account-arrow"]')

    rewards.forEach(reward => {
      const div = document.createElement('div')
      div.className = 'MarketingRewards__singleReward'
      div.innerHTML = `
        <div class="MarketingRewards__singleReward__points">
          <span class="rmh1">${reward.amount}</span>
          <span class="btn-link">POINTS</span>
        </div>
        <div class="MarketingRewards__singleReward__arrow">
          ${accountArrow.innerHTML}
        </div>
        <div class="MarketingRewards__singleReward__money">
          <span class="rmh1">${formatMoney(reward.discount_amount_cents)}</span>
          <span class="MarketingRewards__singleReward__spacer"></span>
        </div>
      `
      dom.$rewardsList.append(div)
    })
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.MarketingImageTextList = this
  }
}
